import { Injectable } from '@angular/core';
import { AlarmLogRequest } from '../SicorService/RequestObject/AlarmLogRequest';
import { AlarmLog } from '../../models/AlarmLog';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { GlobalMethodsService } from '../global-methods.service';
import { OcLogRequest } from '../SicorService/RequestObject/OcLogRequest';
import { OcLog } from 'src/app/models/OcLog';
import { NavigationService } from './navigation.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { ModalController } from '@ionic/angular';
import { ImageNotificationRequest } from '../SicorService/RequestObject/ImageNotificationRequest';
import { firstValueFrom } from 'rxjs';
import { DeviceLogRequest } from '../SicorService/RequestObject/DeviceLogRequest';

@Injectable({
  providedIn: 'root'
})
export class HistoricalService {

  constructor(private sicorAPI: SicorApiService,
    public gms: GlobalMethodsService,
    private navigation: NavigationService,
    private modalCtrl: ModalController,
    private translate: TranslateConfigService) { }

  public async getAlarmsLog(alarmLogRequest: AlarmLogRequest): Promise<AlarmLog[]> {
    let alarmsLogList: AlarmLog[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestAlarmsLog(alarmLogRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet.length != 0) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'historicalModal');
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                if (res.resultSet.length === 1 && res.resultSet[0].error != null) {
                  if (res.resultSet[0].error === 0) {
                    resolve(alarmsLogList);
                  }
                  else {
                    resolve(null);
                  }
                }
                alarmsLogList = res.resultSet;
                for (let i = 0; i < res.resultSet.length; i++) {
                  if (alarmsLogList[i].misc6 != '' && alarmsLogList[i].misc6 != 'GPS') {
                    if (alarmsLogList[i].misc6.indexOf('http') !== -1) {
                      alarmsLogList[i].misc6 = alarmsLogList[i].misc6.toLowerCase();
                    }
                    else {
                      let urlRec = alarmsLogList[i].misc6;
                      if (alarmsLogList[i].misc10 !== 'MP4') {
                        alarmsLogList[i].misc6 = `data:image/jpg;base64,${urlRec}`;
                      } else {
                        alarmsLogList[i].misc6 = `data:video/mp4;base64,${urlRec}`;
                      }
                    }
                  }
                }
                resolve(alarmsLogList)
              }
            }
            else {
              resolve(alarmsLogList);
            }
          }, error: async e => {
            //this.gms.openFailedProcessModal();
            resolve(null);
          }
        })
      ));
    });
  }

  public async getAlarmsLogFilter(deviceLogRequest: DeviceLogRequest): Promise<AlarmLog[]> {
    let alarmsLogList: AlarmLog[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestDevicesLog(deviceLogRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet.length != 0) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'historicalModal');
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                if (res.resultSet.length === 1 && res.resultSet[0].error != null) {
                  if (res.resultSet[0].error === 0) {
                    resolve(alarmsLogList);
                  }
                  else {
                    resolve(null);
                  }
                }
                alarmsLogList = res.resultSet;
                for (let i = 0; i < res.resultSet.length; i++) {
                  if (alarmsLogList[i].misc6 != '' && alarmsLogList[i].misc6 != 'GPS') {
                    if (alarmsLogList[i].misc6.indexOf('http') !== -1) {
                      alarmsLogList[i].misc6 = alarmsLogList[i].misc6.toLowerCase();
                    }
                    else {
                      let urlRec = alarmsLogList[i].misc6;
                      if (alarmsLogList[i].misc10 !== 'MP4') {
                        alarmsLogList[i].misc6 = `data:image/jpg;base64,${urlRec}`;
                      } else {
                        alarmsLogList[i].misc6 = `data:video/mp4;base64,${urlRec}`;
                      }
                    }
                  }
                }
                resolve(alarmsLogList)
              }
            }
            else {
              resolve(alarmsLogList);
            }
          }, error: async e => {
            //this.gms.openFailedProcessModal();
            resolve(null);
          }
        })
      ));
    });
  }

  public async getOcLog(ocLogRequest: OcLogRequest): Promise<OcLog[]> {
    let ocLogList: OcLog[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestOpenCloseLog(ocLogRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'historicalModal');
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                if (res.resultSet.length === 1 && res.resultSet[0].error != null) {
                  if (res.resultSet[0].error === 0) {
                    resolve(ocLogList);
                  }
                  else {
                    resolve(null);
                  }
                }
                ocLogList = res.resultSet;
                resolve(ocLogList);
              }
            } else {
              resolve(ocLogList)
            }
          }, error: async e => {
            this.gms.openFailedProcessModal();
            resolve(ocLogList);
          }
        })
      ));
    });
  }

  public async getImageNotification(imageNotificationRequest: ImageNotificationRequest): Promise<string> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.getImageNotificationRequest(imageNotificationRequest)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet.length != 0) {
              if (res.resultSet[0].error != null) {
                if (res.resultSet[0].error === 401) {
                  this.modalCtrl.dismiss(false, '', 'historicalModal');
                  //this.modalCtrl.dismiss(false,'','loadSpinner');
                  await this.navigation.logout();
                  await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                    'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                } else {
                  resolve('');
                }
              } else {
                if (res.resultSet[0].doc_url != null && res.resultSet[0].doc_url !== '') {
                  resolve(res.resultSet[0].doc_url);
                } else {
                  resolve('');
                }
              }
            } else {
              resolve(null)
            }
          }, error: async e => {
            resolve(null);
          }
        })
      ));
    });
  }
}
